import type { Action, StoreActionApi } from 'react-sweet-state';
import type { ProjectType } from '@atlassian/jira-common-constants';
import { INITIAL_STATE } from '../../../../common/constants/state';
import type { State } from '../../../../common/types';
import { getFirstStep } from '../../../../common/utils/import-steps';

export type SetProjectTypeAction = (type: ProjectType) => Action<State, void, void>;

export const setProjectType =
	(type: ProjectType) =>
	({ setState }: StoreActionApi<State>) => {
		setState({
			projectData: { ...INITIAL_STATE.projectData, type },
			migrationId: null,
			uploadedFileName: null,
			step: getFirstStep({
				projectType: type,
				importType: INITIAL_STATE.importType,
			}),
		});
	};
